import React, { useContext, useEffect, useState } from "react";
import { Grid, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

// Components

const useStyles = makeStyles((theme) => ({}));

const DashboardForm_01 = () => {
  const classes = useStyles();

  const { selected_profile, selected_fb_details, setSelectedFacebookDetails } =
    useContext(FacebookProfilesDashboardContext);

  const [bm_list, setBmList] = useState([]);
  const [ad_list, setAdList] = useState([]);
  const [pixel_list, setPixelList] = useState([]);

  const getLists = (selected) => {
    let bm_list = [];
    let ad_list = [];
    let pixel_list = [];

    selected_profile.bm_account.map((bm) => {
      // bm_list.push(bm.bm_account_name + " - " + bm.bm_account_id);
      bm_list.push(bm);
    });
   
    selected_profile.ad_account.map((ad) => {
      if (ad.bm_account_id === selected.id) {
        // if (ad.ad_account_status === 1) {
        // ad_list.push(ad.ad_account_name + " - " + ad.ad_account_id);
        ad_list.push(ad);

        if (ad.ad_account_id === selected.ad_account) {
          ad.pixels.map((pixel) => {
            if (!pixel_list.includes(pixel.id)) {
              pixel_list.push(pixel);
            }
          });
        }
        // }
      }
    });

    return [bm_list, ad_list, pixel_list];
  };

  const handleChange = (e) => {
    let dup_selected = JSON.parse(JSON.stringify(selected_fb_details));
    dup_selected[e.target.name] = e.target.value;

    if (e.target.name === "business_manager") {
      dup_selected["ad_account"] = "";
      dup_selected["pixel"] = "";
    } else if (e.target.name === "ad_account") {
      dup_selected["pixel"] = "";
    }

    // let [bm_list, ad_list, pixel_list] = getLists(dup_selected);

    // ad_list = ad_list.map((ad) => {
    //   return ad.ad_account_id;
    // });

    // pixel_list = pixel_list.map((pixel) => {
    //   return pixel.id;
    // });

    // if (!ad_list.includes(dup_selected.ad_account)) {
    //   dup_selected["ad_account"] = ad_list[0] ? ad_list[0] : "";
    // }

    // if (!pixel_list.includes(dup_selected.pixel)) {
    //   dup_selected["pixel"] = pixel_list[0] ? pixel_list[0] : "";
    // }

    setSelectedFacebookDetails(dup_selected);
  };

  useEffect(() => {
    const [bm_list, ad_list, pixel_list] = getLists(selected_fb_details);

    setBmList(bm_list);
    setAdList(ad_list);
    setPixelList(pixel_list);
  }, [selected_profile, selected_fb_details]);

  return (
    // 1st Column
    <Grid item xs={4} container direction="column" spacing={1}>
      {" "}
      {/* Business Manager */}{" "}
      <Grid item>
        <TextField
          fullWidth
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Business Manager"
          id="id"
          name="id"
          value={
            selected_fb_details.id
              ? selected_fb_details.id
              : "select"
          }
          onChange={handleChange}
          // error={}
          // helperText={}
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {bm_list.map((each) => {
            return (
              <option key={each.bm_account_id} value={each.id}>
                {" "}
                {each.bm_account_name}({each.bm_account_id}){" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      {/* Ad Account */}{" "}
      <Grid item>
        <TextField
          fullWidth
          select
          SelectProps={{
            native: true,
          }}
          size="small"
          margin="dense"
          label="Ad Account"
          id="ad_account"
          name="ad_account"
          value={
            selected_fb_details.ad_account
              ? selected_fb_details.ad_account
              : "select"
          }
          onChange={handleChange}
        >
          <option value="select" disabled>
            -- - select one-- -
          </option>{" "}
          {ad_list.map((each) => {
            return (
              <option key={each.ad_account_id} value={each.ad_account_id}>
                {" "}
                {each.ad_account_name}({each.ad_account_id}){" "}
              </option>
            );
          })}{" "}
        </TextField>{" "}
      </Grid>
      {/* Pixel */}{" "}
      {/* <Grid item>
                    <TextField
                      fullWidth
                      select
                      SelectProps={{ native: true }}
                      size="small"
                      margin="dense"
                      label="Pixel"
                      id="pixel"
                      name="pixel"
                      value={
                        selected_fb_details.pixel ? selected_fb_details.pixel : "select"
                      }
                      onChange={handleChange}
                    >
                      <option value="select" disabled>
                        --- select one---
                      </option>
                      {pixel_list.map((each) => {
                        return (
                          <option key={each.id} value={each.id}>
                            {each.name} ({each.id})
                          </option>
                        );
                      })}
                    </TextField>
                  </Grid> */}{" "}
    </Grid>
  );
};

export default DashboardForm_01;
